import { PaginatedResponse, RefServiceView } from "@/types";
import { apiUrl } from "../../utils/url";
import { ServiceResponse } from "./types";
import { HttpClient } from "../HttpClient";
import { toServiceError } from "../errors";
import { IRefServicesService } from "./IRefServicesService";

export class RefServicesService implements IRefServicesService {
  private httpClient: HttpClient;

  constructor() {
    this.httpClient = new HttpClient({
      baseURL: apiUrl,
      timeout: 10000,
      headers: {},
    });
  }

  async getByServiceType(serviceTypeId: string): Promise<RefServiceView[]> {
    try {
      return await this.httpClient.get<RefServiceView[]>(
        `/refServices/serviceType/${serviceTypeId}`,
      );
    } catch (error) {
      throw toServiceError(
        error,
        "Não foi possível carregar os serviços. Atualize a página e tente novamente.",
      );
    }
  }

  async getAll(): Promise<PaginatedResponse<RefServiceView>> {
    try {
      return await this.httpClient.get<PaginatedResponse<RefServiceView>>(
        `/refServices?size=100`,
      );
    } catch (error) {
      throw toServiceError(
        error,
        "Não foi possível carregar os serviços. Atualize a página e tente novamente.",
      );
    }
  }

  async getRefServices(page: number, size: number): Promise<ServiceResponse> {
    try {
      const query = new URLSearchParams({
        page: page.toString(),
        size: size.toString(),
      });
      return await this.httpClient.get<ServiceResponse>(
        `/refServices?${query.toString()}`,
      );
    } catch (error) {
      throw toServiceError(
        error,
        "Não foi possível carregar os serviços. Atualize a página e tente novamente.",
      );
    }
  }
}
